import React from 'react';
import Image from '../../../img/MainWebsite/StoresPage.png';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

function ForStores() {

  const navigate = useNavigate();

  return (
    <main >
      <Header />
      <div className={'mainContent whiteFont'}>
        <div className={'column'}>
          <h2 className={'blue left'}>SMARTER SHOPPING EXPERIENCE  </h2>
          <h5 className={'left'}>Designed for Retail: </h5>
          <ul className={"two-columns"}>
            <li className={'blue left'}><h5>Clear, menu-style product presentation </h5></li>
            <li className={'blue left'}><h5>Accessible on customers’ own phones or tablets </h5></li>
            <li className={'blue left'}><h5>Supports self-guided exploration  </h5></li>
            <li className={'blue left'}><h5>Reduces repetitive staff questions </h5></li>
            <li className={'blue left'}><h5>Generate additional revenue  </h5></li>
            <li className={'blue left'}><h5>No investment, no setup fees, no hardware, no training, no downloads, and no financial risk </h5></li>
            <li className={'blue left'}><h5>Exclusively branded for your store </h5></li>
          </ul>
          <h5 className={'left'}>In any retail environment, customers make better decisions when information is clear, accessible, and easy to
            navigate. When guidance is limited, shoppers hesitate, ask more questions, or leave without making a purchase. </h5>
          <h5 className={'left'}>Vizo Menu brings a clear, menu-style presentation to retail spaces, giving customers an intuitive way to explore
            products on their phones or tablets. With organized categories, helpful descriptions, and visuals, shoppers gain
            the context they need to browse confidently and make informed choices at their own pace. </h5>
          <h5 className={'left'}>Designed to complement in-store staff, Vizo Menu answers common questions upfront and reduces friction
            during busy periods. This allows teams to focus on service and higher-value interactions, while customers feel
            more comfortable and informed throughout the shopping experience. </h5>
          <h5 className={'left'}>Retailers can strengthen engagement, support confident purchasing
            decisions, and introduce an additional revenue stream through well-chosen sponsorships that enhance—rather
            than interrupt—the customer experience, all without adding operational complexity. </h5>
          <h5 className={'left'}>Vizo Menu integrates unobtrusively into the retail environment and requires no setup fees, no hardware, no
            training, no downloads, and no financial risk. The experience is exclusively branded for your store and provided
            at no investment, making it a simple, low-risk way to elevate how products are presented in-store. </h5>
          <h5 className={'blue left italic'}>Helping customers shop with confidence—clearly and comfortably. </h5>
        </div>
        <div className={'column'}>
          <img src={Image} className={'page-image image-border'} alt="Image 2" />
          <button className={'button-spacing chrome-background blue link'} onClick={() => { navigate("Contact-Us") }}>
            CONTACT US TO SCHEDULE A DEMO
          </button>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default ForStores;